import api from './api';

export interface Image {
  id: number;
  title: string;
  description: string;
  image_file: File | null;
  image_file_url: string | null;
  thumbnail: File | null;
  thumbnail_url: string | null;
  width: number | null;
  height: number | null;
  is_public: boolean;
  is_deleted: boolean;
  tags: string[];
  created_by: number;
  created_by_name: string;
  created_at: string;
  updated_at: string;
  can_edit: boolean;
  order: number;
  container: number | null;
}

class ImageService {
  async getAll(params?: any): Promise<Image[]> {
    const response = await api.get('/images/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getImage(id: number): Promise<Image> {
    const response = await api.get(`/images/${id}/`);
    return response.data;
  }

  async create(data: FormData): Promise<Image> {
    const response = await api.post('/images/', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async update(id: number, data: FormData | Partial<Image>): Promise<Image> {
    const headers = data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {};
    const response = await api.patch(`/images/${id}/`, data, { headers });
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/images/${id}/`);
  }

  async duplicate(id: number): Promise<Image> {
    const response = await api.post(`/images/${id}/duplicate/`);
    return response.data;
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/images/reorder/', { items });
  }

  async getAvailableImages(): Promise<Image[]> {
    const response = await api.get('/images/available/');
    return response.data;
  }

  async getAllForPicker(search?: string): Promise<Image[]> {
    const params: any = {};
    if (search) params.search = search;
    const response = await api.get('/images/all_for_picker/', { params });
    return response.data;
  }
}

const imageService = new ImageService();
export default imageService;
